import * as hookForm from "react-hook-form";

import { superstructResolver } from "./helpers/superstructResolver";
import { UseFormProps, UseFormReturn } from "./helpers/types";

/**
 * It's a thin wrapper around the `useForm` hook from `react-hook-form` lib.
 * It requires validation struct built upon `superstruct` lib utilities
 *
 * The hook takes the following props
 * - `defaultValues` - default values for the form inputs
 * - `struct` - superstruct's object schema defining the form validation
 */
export function useForm<T extends Record<string, unknown>>({
  struct,
  defaultValues,
}: UseFormProps<T>): UseFormReturn<T> {
  return hookForm.useForm({
    mode: "all",
    resolver: superstructResolver(struct),
    defaultValues,
  });
}
